import { StringUtil } from '@kutil';
import { Deserializable } from './deserializable.model';

export interface LegalDocumentItem {
  type: string;
  latestVersion: number;
  signed: boolean;
}

export class LegalDocument implements Deserializable<any, LegalDocument> {
  constructor(
    public id?: string,
    public type?: LegalDocumentType,
    public summary?: string,
    public content?: string,
    public version?: number,
    public effectiveDate?: string,
    public dateCreated?: string
  ) {}

  get contentAsParsedHtml(): string {
    return StringUtil.contentAsParsedHtml(this.content);
  }

  deserialize(input: any): LegalDocument {
    if (input == null) {
      return null;
    }

    this.id = input['id'];
    this.type = input['type'] as LegalDocumentType;
    this.summary = input['summary'];
    this.content = input['content'];
    this.version = input['version'];
    this.effectiveDate = input['effectiveDate'];
    this.dateCreated = input['dateCreated'];

    return this;
  }
}

export enum LegalDocumentType {
  EULA = 'EULA',
  PRIVACY = 'PRIVACY',
}
